import { render, staticRenderFns } from "./CredenciamentoUnicoFileUpload.vue?vue&type=template&id=502988d9&scoped=true"
import script from "./CredenciamentoUnicoFileUpload.vue?vue&type=script&lang=js"
export * from "./CredenciamentoUnicoFileUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "502988d9",
  null
  
)

export default component.exports